import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import { httpClient, apiUrl } from "../../restProvider";

// Simple Android detection from user agent
export const isAndroid = () =>
    typeof navigator !== "undefined" &&
    /android/i.test(navigator.userAgent || "");

const sanitizeButtonProps = ({ activeClassName, ...props }) => props;

const LinkMemberWallet = ({ label, children, ...props }) => {
    const walletUrl = `${apiUrl}/wallet/add`;
    const [loading, setLoading] = useState(false);

    //  if (!isAndroid()) return null;

    const handleClick = async (event) => {
        event.preventDefault();
        if (loading) return;
        setLoading(true);
        try {
            // Optional warm-up: ensure session is valid (no token needed client-side)
            await httpClient(`${apiUrl}/authtoken`);
            // Navigate in same tab to avoid popup blockers and ensure Android deep link handling
            window.location.href = walletUrl;
        } catch (e) {
            // optionally report error
        } finally {
            setLoading(false);
        }
    };

    return (
        <Button
            {...sanitizeButtonProps(props)}
            onClick={handleClick}
            disabled={loading}
            // Render as a neutral clickable wrapper so images look like native badges
            variant="text"
            color="default"
            size="small"
            style={{
                padding: 0,
                minWidth: 0,
                background: "transparent",
                boxShadow: "none",
            }}
            to={{
                pathname: walletUrl,
            }}
        >
            {children || label}
        </Button>
    );
};

export default LinkMemberWallet;
